import React, { useState, useEffect, useRef } from "react";
import Tooltip from "../../../Elements/Tooltip/Tooltip.js";
import { typeInput } from "../Helpers/JsonLists.js";
import FormCheckboxComponent from "./FormCheckboxComponent.js";
import FormRadioComponent from "./FormRadioComponent.js";
import FormSelectComponent from "./FormSelectComponent.js";
import { useContent } from "../../../../contexts/contentContext/contentContext.js";
import DateInput from "../../../Elements/DateInput/DateInput.js";
import parse from "html-react-parser";
import RecipientDropdownList from "../../../Pages/CreateJumboForm/CreateJumboFormContent/NewFormBuilder/FormBuilderEditFields/FormBuilderRecipientElement/components/RecipintDropdownList.jsx";

const DisplayEmbedInputs = ({
  field,
  fieldKey,
  buttonsColor,
  embedJson,
  setEmbedJson,
  isErrorField,
  prevCookie,
  urlParameter,
  errorFields,
  direction,
  isDemoEmbedPage,
}) => {
  const { getTextByKey } = useContent();
  const [isDropdownOpen, setIsDropdownOpen] = useState(false);


  const [inputChange, setInputChange] = useState(prevCookie ? prevCookie : "");
  const [classBlank, setClassBlank] = useState(false);
  const [isRequiredError, setIsRequiredError] = useState(false);
  const [isError, setIsError] = useState(false);
  const [blurTextArea, setBlurTextArea] = useState(false);
  const fieldRef = useRef();
  const textareaRef = useRef();
  useEffect(() => {
    if (
      errorFields.filter(
        (element) => element.item.Lead_Dynamic_Field_Order === fieldKey
      ).length > 0
        ? true
        : false
    ) {
      setIsError(true);
    } else {
      setIsError(false);
    }
  }, [errorFields]);

  const handleChangeSimpleInput = (e) => {
    if (typeInput[field.template].type === "number") {
      //check regex for number but not e
      if (e.match(/^[0-9]*$/)) {
        setInputChange(e);
        setIsError(false);
        setIsRequiredError(false);
      }
    } else {
      setInputChange(e);
      setIsError(false);
      setIsRequiredError(false);
    }
  };

  useEffect(() => {
    if (inputChange) {
      setClassBlank(true);
      setIsRequiredError(false);
      if (
        inputChange === "error" &&
        typeInput[field.template].htmlType === "dateInput"
      ) {
        setClassBlank(false);
      }
    } else {
      if (field.fields.required) {
        setIsRequiredError(true);
      }
    }
    let tempList = embedJson;
    tempList[fieldKey].TextValue = inputChange;
    setEmbedJson(tempList);
  }, [inputChange]);

  useEffect(() => {
    if (typeInput[field.template].htmlType !== "checkbox") {
      if (typeInput[field.template].htmlType === "dateInput") {
        if (urlParameter) {
          setInputChange(
            urlParameter ? urlParameter : prevCookie ? prevCookie : ""
          );
        }
      } else {
        let tempInputChage = urlParameter
          ? urlParameter
          : prevCookie
          ? prevCookie
          : "";
        if (field.fields.textarea) {
          tempInputChage += field.fields.textarea;
        }
        setInputChange(tempInputChage);
      }
    }
  }, [field]);

  useEffect(() => {
    if (
      field.template === "recipientDropdown" &&
      field.fields?.dropdownSavedRecipients?.length > 0
    ) {
      setIsError(false);
      setIsRequiredError(false);
      setClassBlank(true);
    }
  }, [field.fields?.dropdownSavedRecipients]);

  const handleChangeClassBlank = () => {
    if (inputChange) {
      setClassBlank(true);
    } else {
      setClassBlank(false);
    }
    if (typeInput[field.template].htmlType === "textarea") {
      setBlurTextArea(true);
    }
  };

  const tooltipIcon = (color) => {
    return (
      <svg
        className="tooltip-question"
        width="20"
        height="20"
        viewBox="0 0 20 20"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
      >
        <circle cx="10" cy="10" r="9.5" stroke={color} />
        <path
          d="M9.44043 13.1973C9.44954 12.6549 9.51107 12.2266 9.625 11.9121C9.73893 11.5977 9.97135 11.249 10.3223 10.8662L11.2178 9.94336C11.6006 9.51042 11.792 9.04557 11.792 8.54883C11.792 8.07031 11.6667 7.69661 11.416 7.42773C11.1654 7.1543 10.8008 7.01758 10.3223 7.01758C9.85742 7.01758 9.48372 7.14062 9.20117 7.38672C8.91862 7.63281 8.77734 7.96322 8.77734 8.37793H7.5127C7.52181 7.63965 7.78385 7.04492 8.29883 6.59375C8.81836 6.13802 9.49284 5.91016 10.3223 5.91016C11.1836 5.91016 11.8535 6.14258 12.332 6.60742C12.8151 7.06771 13.0566 7.70117 13.0566 8.50781C13.0566 9.30534 12.6875 10.0915 11.9492 10.8662L11.2041 11.6045C10.8714 11.9736 10.7051 12.5046 10.7051 13.1973H9.44043ZM9.38574 15.3643C9.38574 15.1592 9.44727 14.9883 9.57031 14.8516C9.69792 14.7103 9.88477 14.6396 10.1309 14.6396C10.377 14.6396 10.5638 14.7103 10.6914 14.8516C10.819 14.9883 10.8828 15.1592 10.8828 15.3643C10.8828 15.5693 10.819 15.7402 10.6914 15.877C10.5638 16.0091 10.377 16.0752 10.1309 16.0752C9.88477 16.0752 9.69792 16.0091 9.57031 15.877C9.44727 15.7402 9.38574 15.5693 9.38574 15.3643Z"
          fill={color}
        />
      </svg>
    );
  };

  useEffect(() => {
    if (
      textareaRef &&
      textareaRef !== undefined &&
      textareaRef.current &&
      textareaRef.current !== undefined
    ) {
      if (blurTextArea && inputChange) {
        //set the height of the textarea textareaRef to the scrollHeight
        textareaRef.current.style.height = "auto";
        textareaRef.current.style.height =
          textareaRef.current.scrollHeight + "px";
      } else if (!blurTextArea) {
        textareaRef.current.style.height = "auto";
        textareaRef.current.style.height =
          textareaRef.current.scrollHeight + "px";
      }
    }
  }, [blurTextArea, inputChange]);

  const [selectedRecipientPreviewName, setSelectedRecipientPreviewName] =
    useState("");
  useEffect(() => {
    setSelectedRecipientPreviewName("");
    if (field.fields.dropdownSavedRecipients?.length > 0) {
      const savedResipientsName = field.fields.dropdownSavedRecipients.map(
        (recipient) => {
          const fullRecipient = field.fields.recipients.find(
            (r) => r.id === recipient.id
          );
          return fullRecipient.name;
        }
      );
      setSelectedRecipientPreviewName(savedResipientsName.join(", "));
    }
  }, [field.fields.dropdownSavedRecipients, field.fields.recipients]);


  const renderField = () => {
    switch (typeInput[field.template].htmlType) {
      case "input":
        return (
          <div className="input general">
            <div
              className={`field-title ${classBlank ? "" : "blank"} ${
                field.fields.readonly ? "read-only" : ""
              }`}
            >{`${
              isDemoEmbedPage
                ? getTextByKey(field.fields.label)
                : field.fields.label
            }${field.fields.required ? "*" : ""}`}</div>
            <input
              onFocus={() => {
                setClassBlank(true);
              }}
              onBlur={() => handleChangeClassBlank()}
              onChange={(e) => handleChangeSimpleInput(e.target.value)}
              value={inputChange}
              className={`${field.fields.readonly ? "readOnly" : ""}`}
              readOnly={field.fields.readonly}
              disabled={field.fields.readonly ? "disabled" : false}
              //autoComplete={typeInput[field.template].type}
              type={typeInput[field.template].type}
              // placeholder={`${field.fields.label}${
              //   field.fields.required ? "*" : ""
              // }`}
              name={typeInput[field.template].type}
              title={`${
                field.fields.readonly
                  ? "read only"
                  : isDemoEmbedPage
                  ? getTextByKey(field.fields.label)
                  : field.fields.label
              }`}
            />
          </div>
        );
      case "dateInput":
        return (
          <div className={`input dateInput`}>
            <div
              className={`field-title ${classBlank ? "" : "blank"} ${
                field.fields.readonly ? "read-only" : ""
              }`}
            >{`${field.fields.label}${field.fields.required ? "*" : ""}`}</div>
            <div
              className={`div-input-date-field ${
                classBlank ? "" : "hide-placeholder"
              }`}
              onFocus={() => setClassBlank(true)}
              onBlur={() => handleChangeClassBlank()}
            >
              <DateInput
                date={inputChange ? inputChange : ""}
                setDate={setInputChange}
              />
            </div>
          </div>
        );
      case "textarea":
        return (
          <div className="input general textareaInput">
            <label
              for="textarea-input-form"
              className={`field-title ${classBlank ? "" : "blank"}`}
            >{`${
              isDemoEmbedPage
                ? getTextByKey(field.fields.label)
                : field.fields.label
            }${field.fields.required ? "*" : ""}`}</label>
            <textarea
              onFocus={() => {
                setClassBlank(true);
                setBlurTextArea(false);
              }}
              id="textarea-input-form"
              ref={textareaRef}
              onBlur={() => handleChangeClassBlank()}
              onChange={(e) => handleChangeSimpleInput(e.target.value)}
              value={inputChange}
              className={`${field.fields.readonly ? "readOnly" : ""} ${
                classBlank ? "" : "blank-textarea"
              } ${blurTextArea && inputChange ? "not-blank-with-value" : ""}`}
              readOnly={field.fields.readonly}
              //placeholder={field.fields.label}
            />
          </div>
        );
      case "checkbox":
        return (
          <FormCheckboxComponent
            field={field}
            urlParameter={urlParameter}
            prevCookie={prevCookie}
            buttonsColor={buttonsColor}
            inputChange={inputChange}
            setInputChange={setInputChange}
            handleChangeSimpleInput={handleChangeSimpleInput}
          />
        );
      case "radio":
        return (
          <FormRadioComponent
            field={field}
            urlParameter={urlParameter}
            prevCookie={prevCookie}
            buttonsColor={buttonsColor}
            handleChangeSimpleInput={handleChangeSimpleInput}
          />
        );
      case "select":
        return (
          <FormSelectComponent
            field={field}
            urlParameter={urlParameter}
            prevCookie={prevCookie}
            buttonsColor={buttonsColor}
            handleChangeSimpleInput={handleChangeSimpleInput}
          />
        );
      case "sperator-static":
        return (
          <div className="input general">
            <span className={field.template}></span>
          </div>
        );
      case "text-static":
        return (
          <div className="input general">
            <span className={field.template}>{parse(field.fields.label)}</span>
          </div>
        );
      case "title-static":
        return (
          <div className="input general">
            <span className={field.template}>{field.fields.label}</span>
          </div>
        );
      case "recipientDropdown":
        return (
          <div
            className="input general recipient-dropdown"
            onClick={(e) => {
              e.stopPropagation();
              if (!e.target.closest(".recipient-dropdown-content-wrapper")) {
                setIsDropdownOpen(!isDropdownOpen);
              }
            }}
          >
            <div
              className={`field-title ${
                classBlank ? "" : "blank"
              } dropdown-label-text`}
            >
              <span
                style={{
                  maxWidth: "calc(100% - 20px)",
                  overflow: "hidden",
                  textOverflow: "ellipsis",
                  whiteSpace: "nowrap",
                  display: "block",
                }}
              >
                {`${
                  field.template === "recipientDropdown" &&
                  selectedRecipientPreviewName
                    ? selectedRecipientPreviewName
                    : isDemoEmbedPage
                    ? getTextByKey(field.fields.label)
                    : field.fields.label
                }${field.fields.required ? "*" : ""}`}
              </span>
              <i
                className={`fa fa-caret-down ${
                  !isDropdownOpen ? "is-closed-dropdown-arrow" : ""
                }`}
                aria-hidden="true"
              ></i>
            </div>
            {isDropdownOpen && (
              <RecipientDropdownList
                item={field}
                setIsDropdownOpen={setIsDropdownOpen}
                setFormItems={setEmbedJson}
                formItems={embedJson}
                selectedRecipientPreviewName={selectedRecipientPreviewName}
                setSelectedRecipientPreviewName={
                  setSelectedRecipientPreviewName
                }
              />
            )}
          </div>
        );
      default:
        return (
          <div className="input general">
            <input
              className={`${field.fields.readonly ? "readOnly" : ""}`}
              readOnly={field.fields.readonly}
              disabled={field.fields.readonly ? "disabled" : false}
              autoComplete={typeInput[field.template].type}
              type={typeInput[field.template].type}
              placeholder={`${field.fields.label}${
                field.fields.required ? "*" : ""
              }`}
              title={`${
                field.fields.readonly ? "read only" : field.fields.label
              }`}
            />
          </div>
        );
    }
  };

  //Jump to the first error field in form
  useEffect(() => {
    if (errorFields.length > 0) {
      const firstError = errorFields[0];
      if (firstError.item.Lead_Dynamic_Field_Order === fieldKey) {
        //jump to top of fieldRef
        fieldRef.current.scrollIntoView({
          behavior: "smooth",
          block: "start",
        });
      }
    }
  }, [errorFields]);

  return (
    <>
      {field && (
        <div
          ref={fieldRef}
          className={`form-input ${isError ? "error" : ""} type-${
            typeInput[field.template].htmlType
          }`}
        >
          {renderField()}{" "}
          {field.fields.helptext ? (
            <div
              className={`field-tooltip ${direction === "rtl" ? "right" : ""}`}
            >
              <Tooltip
                id={"field-" + fieldKey}
                tooltipText={field.fields.helptext}
                //hardPositioned
                top
              >
                {tooltipIcon(
                  buttonsColor.includes("#") ? buttonsColor : "#" + buttonsColor
                )}
              </Tooltip>
            </div>
          ) : null}
        </div>
      )}
      {isError && (
        <div className="error-text">
          {field.template === "recipientDropdown" && field.fields.required
            ? getTextByKey("choose-recipient-text")
            : isRequiredError
            ? getTextByKey("is-required-field")
            : getTextByKey("invalid-field")}
        </div>
      )}
    </>
  );
};

export default DisplayEmbedInputs;
